<script setup lang="ts">
const { t } = useTexts();
const { getLoginHistory, loginHistory, loadingUserHistory } = useUserHistory();
const { setCurrentMenuOpenByGroup } = useAccountMenuStore();

function changePage({ page }: { page: number }) {
  getLoginHistory(page);
}

useSeo({
  title: t('account.login_history.title'),
});

onMounted(() => {
  setCurrentMenuOpenByGroup('user-account');
  getLoginHistory();
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-account"
    :title="$t('account.login_history.title')"
  >
    <UserBox>
      <BaseLoading
        class="!bg-auth-bg-primary !absolute"
        :icon-loader="true"
        :show="loadingUserHistory"
      />

      <UserTableSkeleton v-if="loadingUserHistory" />

      <UserTableNew
        v-else
        :key="'login-history'"
        :current-page="loginHistory?.current_page"
        :items="loginHistory?.data"
        :per-page="loginHistory?.per_page"
        :table-type="'login-history'"
      />

      <UserTablePagination
        :key="loginHistory?.current_page"
        :end="loginHistory?.to || 1"
        :last-page="loginHistory?.last_page || 1"
        :page="loginHistory?.current_page || 1"
        :per-page="loginHistory?.per_page || 15"
        :start="loginHistory?.from || 1"
        :total="loginHistory?.total || 1"
        @change-page="changePage"
      />
    </UserBox>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.formContainer {
  .formGroup {
    @apply mb-2;

    label {
      @apply text-xs font-medium;
      span {
        @apply text-error;
      }
    }
  }

  .btnSubmit {
    @apply bg-button-bg text-button-text py-2 px-4 rounded-md text-sm font-semibold whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed;
  }
}
</style>
